export default "__VITE_ASSET__DWePQyF1__"